import { addMinutes } from 'date-fns/addMinutes';
import { format as formatDate } from 'date-fns/format';
import { isValid } from 'date-fns/isValid';
import { format as formatDateWithTimezone } from 'date-fns-tz/format';
import { toZonedTime } from 'date-fns-tz/toZonedTime';

export const getFormattedDate = (
  dateInput: Date | string,
  format?: string,
  fixedTimezone?: string,
  hideTime = false,
) => {
  let date = dateInput;

  if (typeof date === 'string') {
    date = new Date(date);
  }

  if (!isValid(date)) {
    return dateInput as string;
  }

  if (fixedTimezone) {
    const timezoneDate = toZonedTime(date, fixedTimezone);
    return hideTime
      ? formatDateWithTimezone(timezoneDate, 'MMM d, yyyy')
      : formatDateWithTimezone(timezoneDate, format ?? 'MMM d, yyyy', {
          timeZone: fixedTimezone,
        });
  }
  const dateUtc = addMinutes(date, date.getTimezoneOffset());
  return formatDate(dateUtc, format ?? 'MMM d, yyyy');
};
